export const ColumnWidthClasses = {
  WIDTH_12_12: ['wf-w-full', 'wf-relative'],
  WIDTH_11_12: ['wf-w-11/12', 'wf-relative'],
  WIDTH_10_12: ['wf-w-10/12', 'wf-relative'],
  WIDTH_9_12: ['wf-w-9/12', 'wf-relative'],
  WIDTH_8_12: ['wf-w-8/12', 'wf-relative'],
  WIDTH_7_12: ['wf-w-7/12', 'wf-relative'],
  WIDTH_6_12: ['wf-w-6/12', 'wf-relative'],
  WIDTH_5_12: ['wf-w-5/12', 'wf-relative'],
  WIDTH_4_12: ['wf-w-4/12', 'wf-relative'],
  WIDTH_3_12: ['wf-w-3/12', 'wf-relative'],
  WIDTH_2_12: ['wf-w-2/12', 'wf-relative'],
  WIDTH_1_12: ['wf-w-1/12', 'wf-relative'],
}